import { InAppBrowser } from '@app/core/services/in-app-browser/in-app-browser.service';
import { Capacitor } from "@capacitor/core";
import { SharedService } from "../shared/shared.service";
import { NavigationClient } from "@azure/msal-browser";
export class CustomNavigationClient extends NavigationClient {
  constructor(private iab: InAppBrowser, private sharedService: SharedService) {
    super();
  }
  override async navigateExternal(url: string, options: any) {
    if (Capacitor.isNativePlatform()) {

      const browser = this.iab.create(url, "_blank", {});
      browser.on("loadstart").subscribe((event) => {
        if (event.url.includes("#code")) {
          // Close the in app browser and redirect to localhost + the state parameter
          browser.close();

          let baseUrl = "http://localhost/add-files";
          if (Capacitor.getPlatform() == "ios") {
            baseUrl = "capacitor://localhost/add-files";
          }

          const domain = event.url.split("#")[0];
          const url = event.url.replace(domain, baseUrl);
          window.location.href = url;
        }
      });
      browser.on("exit").subscribe(() => {
        this.sharedService.checkStorageAccountStatus.next(true);
      });
    } else {
      if (options.noHistory) {
        window.location.replace(url);
      } else {
        window.location.assign(url);
      }
    }
    return true;
  }
}
